import React, { useEffect, useRef } from 'react';
// import { useHistory } from 'react-router';
// import lodash from 'lodash'
// import config from '../../config.json';
// import apiRequest from '../../utils/api.request';
// import { parseQueryString } from '../../utils/utils'
// import { vaccinationApiRequestBody } from './VaccinationDetailsWrapper/Utils/vaccinationApiRequestBody';

// import expressInterest from '../../images/expressInterest.svg';
// import nextArrow from '../../images/nextArrow.png';
// import vaccinationInfo from '../../images/vaccinationInfo.svg';
// import vaccinationCertification from '../../images/vaccinationCertification.svg';

// import VaccinationDetailsContainer from './VaccinationDetailsContainer'
import VaccinationInfo from '../VaccinationInfo';
import './VaccinationDetails.css';
// import useLoader from '../../hooks/use-loader';
// import useTranslation from '../../hooks/use-translation';

// const get_previous_response_url = config.covid_vacc_base_url + "v1/previous-response/";

const VaccinationDetails = () => {
  // const history = useHistory();
  // const {t} = useTranslation();
  // const { showLoading, hideLoading } = useLoader();
  // // const urlParams = new URLSearchParams(window.location.search);
  // // const queryParams = parseQueryString()
  // // const [previousResponse, _setPreviousResponse] = React.useState(false);
  // // const [previousResponseError, _setPreviousResponseError] = React.useState("");
  // const [loading, _setLoading] = React.useState(false);
  // const user_details = useRef();

  // useEffect(()=>{
  //   _getPreviousResponse();
  // },[])

  // const _getPreviousResponse = async () => {
  //   _setPreviousResponseError("");
  //   const {  source_relation, business_id, source_id, source_user_id, source_user_relation_id, auth_token } = parseQueryString();
  //   if ( auth_token && business_id && source_id && source_user_id && source_relation && source_user_relation_id) {
  //     user_details.current = {
  //       auth_token,
  //       business_id,
  //       source_relation,
  //       source_user_relation_id,
  //       source_id,
  //       source_user_id
  //     }
  //     const dataobj = vaccinationApiRequestBody({}, user_details.current)
  //     showLoading(true);
  //     _setLoading(true);
  //     const response = await apiRequest(get_previous_response_url, dataobj, true);
  //     hideLoading(true);
  //     _setLoading(false);
  //     if (response.status === "success") {
  //       if (String(lodash.get(response,"previous_response")).toLowerCase() == "yes") {
  //         _setPreviousResponse(true);
  //       };
  //     } else {
  //       _setPreviousResponse(false);
  //       _setPreviousResponseError(lodash.get(response,'response.data.message', "Unable to get previous response data. Please refresh page."))
  //     }
  //   }
  // }

  return (
    <div className="paddingLarge">
      <div className="vaccination-div vaccination-details-div">
        <div className="heading-div vaccination-details-heading-div">
          {/* <img className="back-arrow" onClick={() => history.push('/')} src={backArrow} alt="arrow back"></img> */}
          <div><a target="__blank" rel="noopener noreferrer" href="https://production.healthhub.net.in/jiohealthhub/covid19_vaccine/faq"><button className="back-button">FAQ</button></a></div>
        </div>
        {/* <VaccinationDetailsContainer name="Sanjeev Agarwal" hideButton={false} userVaccineInfo={{name:"Covishield", dose: "1", date_of_dose: "2021-04-24"}} /> */}
        <VaccinationInfo />
        {/* <div className="list">
            <a className="list-item" target="__blank" rel="noopener noreferrer" href="https://production.healthhub.net.in/jiohealthhub/covid19_vaccine/faq" >
              <div>
                <img className="list-icon" src={vaccinationInfo} alt="vaccinatine-faq"></img>
                {t("VACCINATION_FAQ")}
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </a>
            <div className="list-item" onClick={() => history.push(`/vaccination-interest?${urlParams.toString()}`)}>
              <div>
                <img className="list-icon" src={expressInterest} alt="express-interest"></img>
                {t("EOI_EXPRESS_INTEREST")}
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div>
            <div className="list-item" onClick={() => history.push(`/vaccination-certificate/verifyjhhid?${urlParams.toString()}`)}>
              <div>
                <img className="list-icon" src={vaccinationCertification} alt="vaccination-certification"></img>
                {t('COWIN_CERT_UPLOAD_HEADER')}
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div> */
            /* <div className="list-item disabled" >
              <div>
                <img className="list-icon" src={bookSlot} alt="book-slot"></img>
                Book Vaccine Slot
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div>
            <div className="list-item disabled">
              <div>
                <img className="list-icon" src={reportSymptoms} alt="report-symptoms"></img>
                Report Post Vaccine Symptoms
              </div>
              <img className="next-arrow" src={nextArrow} alt="next-arrow"></img>
            </div> */
            /* { previousResponse && 
              <div className="vaccination-details-confirm-address-text">
                {`${t("VACCINE_NOTIFICATION_CONFIRM_ADDRESS_TEXT")} `} 
                <a className="vaccination-details-confirm-address-link" rel="noopener" target="_blank" href={`${config.confirm_address_link}?id=${encodeURIComponent(user_details.current.source_user_id)}&buid=${encodeURIComponent(user_details.current.business_id)}`} >
                  {t("EOI_HERE")}
                </a>
                
                <br/><br/>
                {`${t("VACCINE_NOTIFICATION_SYMPTOM_CHECKER")} `} 
                <a className="vaccination-details-confirm-address-link" rel="noopener" target="_blank" href={`${config.symptom_checker_link}?source_id=${queryParams.source_id}&business_id=${encodeURIComponent(queryParams.business_id)}&source_user_id=${encodeURIComponent(queryParams.source_user_id)}&latitude=&longitude=&source_relation=${queryParams.source_relation}&source_user_relation_id=${queryParams.source_user_relation_id}&source_age_years=${queryParams.source_age_years}&source_gender=${queryParams.source_gender}`} >
                  {t("EOI_HERE")}
                </a>
              </div> 
            } */
          /* </div> */}
      </div>
    </div>
  );
};

export default VaccinationDetails;